export const DateFormat = {
	DD: 'DD',
	YYYY_MM_DD: 'YYYY-MM-DD',
	yyyy_MM_dd: 'yyyy-MM-dd',
	DD_MM_YYYY: 'DD/MM/YYYY',
	DD_MM_SLASH: 'DD/MM',
	dddd_Do_MMMM: 'dddd Do MMMM',
	dddd: 'dddd',
	dddd_DD_MM_SLASH: 'dddd DD/MM'
}